// @flow
import { isEmpty } from 'lodash';
import * as React from 'react';

const scrollToFirstError = (errors) => {
    if (!isEmpty(errors)) {
        let fieldElement;
        if (typeof errors.non_field_errors !== 'undefined') {
            fieldElement = document.getElementById('nonFieldErrors');
        }
        if (!fieldElement) {
            let idStr = '';
            const fieldName = Object.keys(errors)[0];
            if (fieldName) {
                if (typeof fieldName === 'object') {
                    idStr = `id-${Object.keys(errors)[0]}.0.${Object.keys(fieldName)[0]}`;
                } else {
                    idStr = `id-${fieldName}`;
                }
            } else {
                idStr = `id-${Object.keys(errors)[0]}`;
            }

            fieldElement = document.getElementById(idStr);

            if (!fieldElement) {
                const selector = `label[for=${idStr}]`;
                fieldElement = document.querySelector(selector);
            }

            if (!fieldElement) {
                fieldElement = document.getElementById(`error-${idStr}`);
            }
        }

        if (fieldElement) {
            fieldElement.scrollIntoView();
        }
    }
};

export default scrollToFirstError;
